<template>
	<div class="form-group mod flex-1">
		<label :for="id" class="form-label" v-if="label">{{ label }}</label>
		<div class="number-counter mod">
			<input
				v-model="val"
				:min="minValue"
				:max="maxValue" value="0"
				type="number"
				class="form-control"
				:id="id"
				@input="$emit('input', val)"
			>
			<div class="input-suffix">{{ metric }}</div>
			<div class="counter-btn inc" @click="plus(id)"></div>
			<div class="counter-btn dec" @click="min(id)"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "InputMinPlus",
		props: [
			"label",
			"id",
			"maxValue",
			"minValue",
			"metric",
		],
		data() {
			return {
				val: 0,
				classMin: "",
				classPlus: "",
				checkId: "",
			}
		},
		mounted() {
			this.inputCalc();
		},
		watch: {
			val: function (v) {
				if (v > this.maxValue) {
					this.val = this.minValue
					this.$emit('input', this.val)
				}
				if (v < this.minValue) {
					this.val = this.maxValue
					this.$emit('input', this.val)
				}
			}
		},
		methods: {
			inputCalc() {
				var self = this;
				$('.number-counter').each(function (i, obj) {
					var inputx = $(this).children('input');
					// var increment = $(this).children('.inc');
					// var decrement = $(this).children('.dec');
					var suffix = $(this).children('.input-suffix');
					var suffixWidth = suffix.width();
					
					// suffix positioning
					suffix.css('left', "calc(50% - (" + suffixWidth + "px / 3) + 3px)");
					suffix.prev().css('padding-right', 'calc(50% + (' + suffixWidth + 'px / 3))');
					
					// select all if click
					inputx.click(function () {
						$(this).select()
					});
					
					// input limit
					inputx.on('input', function () {
						var value = $(this).val();
						if ((value !== '') && (value.indexOf('.') === -1)) {
							$(this).val(Math.max(Math.min(value, $(this).attr('max')), $(this).attr('min')));
						}
						if (value == '') {
							$(this).val($(this).attr('min'));
						}
					});
					
					// // increment button
					// increment.click(function(){
					// 	var inputz = $(this).siblings('input');
					// 	if (inputz.val() < parseInt(inputz.attr('max'))){
					// 		var result = parseInt(inputz.val())+1
					// 		inputz.val(result)
					// 		// self.changeVal(result);
					// 	}
					// });
					//
					// // decrement button
					// decrement.click(function(){
					// 	var inputz = $(this).siblings('input');
					// 	if (inputz.val() > parseInt(inputz.attr('min'))){
					// 		var result = parseInt(inputz.val())-1
					// 		inputz.val(result)
					// 		// self.changeVal(result);
					// 	}
					// });
				})
			},
			changeVal(result) {
				this.val = result
				this.$emit('input', this.val)
			},
			min(id) {
				var inputz = $('input#'+id);
				// if (inputz.val() > parseInt(inputz.attr('min'))){
				var result = parseInt(inputz.val())-1
				inputz.val(result)
				this.changeVal(result);
				// }
			},
			plus(id) {
				var inputz = $('input#'+id);
				// if (inputz.val() < parseInt(inputz.attr('max'))){
				var result = parseInt(inputz.val())+1
				inputz.val(result)
				this.changeVal(result);
				// }
			},
			setValue(val) {
				this.val = val
			}
		}
	}
</script>